import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { SlabsQueries } from '@/services/pointConfiguration/pointConfiguration.queries';
import { SlabsData } from '@/services/pointConfiguration/pointConfiguration.types';
import { useParams, useSearch } from '@tanstack/react-router';
import { getEncryptedPointAgentType } from '../../../../pointConfiguration.constants';

export const useSlabs = () => {
  const search = useSearch({ from: '/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs' });
  const { pointCategoryId } = useParams({
    from: '/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs',
  });
  const dates = parseDateRangeSearch(search.createdDate, { start: 0, end: 0 });
  const { data, isLoading } = useQuery<PaginatedApiResponse<SlabsData[]>>({
    ...SlabsQueries.list({
      agentType: getEncryptedPointAgentType(search.activeTab),
      pointCategoryId,
      row: search.page + 1,
      fetch: search.fetch,
      search: search.q ?? '',
      fromDate: dates?.start ?? 0,
      toDate: dates?.end ?? 0,
    }),
    select: (response) => ({
      ...response,
      data: sortBy(response.data, search.sort),
    }),
  });
  return { slabs: data?.data ?? [], isLoading, meta: data?.meta?.pagination ?? defaultMeta, search, pointCategoryId };
};
